import { render, staticRenderFns } from "./DadosModelo.vue?vue&type=template&id=8cf5e1fa&scoped=true&"
import script from "./DadosModelo.vue?vue&type=script&lang=ts&"
export * from "./DadosModelo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf5e1fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
